import { render, staticRenderFns } from "./classificationmanage.vue?vue&type=template&id=6cfe4ef8&scoped=true&"
import script from "./classificationmanage.vue?vue&type=script&lang=js&"
export * from "./classificationmanage.vue?vue&type=script&lang=js&"
import style0 from "./classificationmanage.vue?vue&type=style&index=0&id=6cfe4ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe4ef8",
  null
  
)

export default component.exports